import { render, staticRenderFns } from "./addStatrgyArticleDialog.vue?vue&type=template&id=d6278870"
import script from "./addStatrgyArticleDialog.vue?vue&type=script&lang=js"
export * from "./addStatrgyArticleDialog.vue?vue&type=script&lang=js"
import style0 from "./addStatrgyArticleDialog.vue?vue&type=style&index=0&id=d6278870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports